import React, { useState, useEffect } from "react";
import { Upload, Modal, Typography, message } from "antd"; // Added message import
import axios from "axios";
import { getToken } from '../../services/AuthService';

import './SurveysDamageUploads.css';

import { PlusOutlined } from '@ant-design/icons';

const { Title } = Typography;

const SurveysDamageUploads = props => {

  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState();
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewTitle, setPreviewTitle] = useState();

  // Function to fetch attachment list
  const fetchAttachments = () => {
    if (props.damageId) {
      axios
        .get(process.env.REACT_APP_API_ENDPOINT + "/damages/attach_list", { params: { damageId: props.damageId } })
        .then(({ data }) => {
          console.log("Fetched attachments:", data);
          const withUrl = data.map(item => {
            const temp = Object.assign({}, item);
            temp.url = process.env.REACT_APP_API_ENDPOINT + "/damages/attach_file/" + item.uid;
            console.log("Created image URL:", temp.url);
            if (!temp.image) {
              temp.thumbUrl = item.name;
            }
            return temp;
          })
          console.log("Final file list:", withUrl);
          setFileList(withUrl);
        })
        .catch(function (error) {
          console.log("Error fetching attachments:", error);
        });
    }
  };

  useEffect(() => {
    fetchAttachments();
  }, [props.damageId]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async file => {
    if (file.image) {
      console.log("Previewing image:", file.url);
      setPreviewImage(file.url);
      setPreviewVisible(true);
      setPreviewTitle(file.name);
    } else {
      console.log("Opening non-image file:", file.url);
      setPreviewVisible(false);
      window.open(file.url, '_blank');
    }
  };

  const handleChange = ({ fileList }) => {
    setFileList([...fileList]);
  };

  const customRequest = async ({ file, onSuccess, onError, onProgress }) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      console.log("Uploading file:", file.name);
      // Track upload progress
      const config = {
        params: { damageId: props.damageId },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${getToken()}`
        },
        onUploadProgress: e => {
          onProgress({ percent: Math.round((e.loaded * 100) / e.total) });
        }
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/damages/attach_file`,
        formData,
        config
      );

      console.log("Upload response:", response.data);

      // First success callback with proper format for Ant Design Upload
      onSuccess({
        name: file.name,
        status: 'done',
        url: null, // We'll get the real URL from fetchAttachments
        thumbUrl: file.type.startsWith('image/') ? await getBase64(file) : null
      });

      // Then refresh the attachment list
      fetchAttachments();
      message.success(`${file.name} uploaded successfully`);
    } catch (error) {
      console.error("Upload error:", error);
      onError(error);
      message.error(`${file.name} upload failed: ${error.message}`);
    }
  };

  const uploadButton = () => {
    return <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  }

  return <div>
    <Title
      className="details_form_header"
      title="Documents"
    />
    <Upload
      customRequest={customRequest}
      listType="picture-card"
      fileList={fileList}
      onPreview={handlePreview}
      onChange={handleChange}
      showDownloadIcon={true}
    >
      {fileList.length >= 20 ? null : uploadButton()}
    </Upload>
    <Modal
      open={previewVisible} 
      title={previewTitle}
      footer={null}
      onCancel={handleCancel}
    >
      <img alt="example" style={{ width: '100%' }} src={previewImage} />
    </Modal>
  </div>;
}

export default (SurveysDamageUploads);